import { alpha, SxProps, Theme } from '@mui/material';

/**
 * Размер круга-подложки под глиф на фото — 40px внутри тач-цели 44×44. Общий
 * для сердца (`FavoriteHeart`) и кнопки «в папку» (`BookmarkFolderButton`):
 * до правки круг вешался прямо на сам svg, и у сердца (холст 41×40)
 * получался не круг, а овал, а у папки (24×24) — круг в край без запаса
 * под тач-цель
 */
export const PHOTO_CHROME_SIZE = 40;

/**
 * Стили круга-подложки под белый глиф на фото: полупрозрачное белое
 * стекло с блюром + тёмная подложка поверх него.
 *
 * Тёмная подложка (`alpha(common.black, 0.24)`) — паритет с мобильным
 * `photoChromeScrim`: без неё белый глиф не читается на светлом фото
 * (например, на белой футболке) — одного белого стекла мало.
 * @param theme - тема MUI, источник цветов подложки
 */
export const getPhotoChromeSx = (theme: Theme): SxProps<Theme> => ({
  width: PHOTO_CHROME_SIZE,
  height: PHOTO_CHROME_SIZE,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100%',
  background: [
    `linear-gradient(${alpha(theme.palette.common.black, 0.24)}, ${alpha(theme.palette.common.black, 0.24)})`,
    alpha(theme.palette.common.white, 0.3)
  ].join(', '),
  boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(10px)'
});
